import { render, staticRenderFns } from "./SpuList.vue?vue&type=template&id=5342b570"
import script from "./SpuList.vue?vue&type=script&lang=js"
export * from "./SpuList.vue?vue&type=script&lang=js"
import style0 from "./SpuList.vue?vue&type=style&index=0&id=5342b570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports